import React from 'react';
import * as S from './payment-method-skeleton.molecule.style';

export const PaymentMethodsSkeleton: React.FC = () => {
  return (
    <S.PaymentContainer>
      {/* Título */}
      <S.TitleSkeleton />

      {/* Métodos de pagamento (radio/cards) */}
      <S.MethodsSkeleton>
        <S.MethodOption />
        <S.MethodOption />
        <S.MethodOption />
      </S.MethodsSkeleton>

      {/* Caixa PIX / BOLETO */}
      <S.PixBoxSkeleton>
        <S.LineSkeleton />
        <S.LineSkeleton />
      </S.PixBoxSkeleton>

      {/* Card do formulário (cartão / apple pay) */}
      <S.CardForm>
        <S.Field>
          <S.LabelSkeleton />
          <S.InputSkeleton />
        </S.Field>

        <S.Field>
          <S.LabelSkeleton />
          <S.InputSkeleton />
        </S.Field>

        <S.FieldRow>
          <S.SmallInput />
          <S.SmallInput />
        </S.FieldRow>

        {/* salvar cartão */}
        <S.CheckboxRow>
          <S.CheckboxSkeleton />
          <S.TextSkeleton />
        </S.CheckboxRow>

        {/* aviso segurança */}
        <S.SecurityNoteSkeleton />
      </S.CardForm>
    </S.PaymentContainer>
  );
};
